import settings from '@/settings'

let post = (notification, headers) => {
    return fetch(`${settings.apetrusApi}/notificacoes/push/`, {
      method: 'POST',
      body: JSON.stringify(notification),
      mode: 'cors',
      headers: headers
    })
  }

  let getAndPut = (headers, data) => {
    const request = {
      method: data.method,
      mode: 'cors',
      headers: headers
    }
    if (data.method === 'GET') request.cache = 'default'
    else request.body = JSON.stringify(data)
    return fetch(`${settings.apetrusApi}/notificacoes/admin/`, request)
}

  export default {
    post,
    getAndPut
}
